import { localizedStringSchema } from "./shared/localizedString.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/banner.ts
const bannerItemSchema = z.object({
	label: z.string(),
	imageUrl: localizedStringSchema,
	mobileImageUrl: localizedStringSchema.nullable(),
	link: localizedStringSchema,
	title: localizedStringSchema.nullable(),
	blank: z.boolean(),
	endTime: z.iso.datetime().nullable()
});
const listBannersOutputSchema = z.object({ items: z.array(bannerItemSchema) });
const bannerContract = oc.prefix("/banners").tag("Banner").router({ list: oc.route({
	summary: "List active home-banner items",
	method: "GET",
	path: "/"
}).output(listBannersOutputSchema) });
//#endregion
export { bannerContract, bannerItemSchema, listBannersOutputSchema };
